import classNames from 'classnames';

import { setupForDark } from '@theme';

function PlaceholderText({ text, className }: { text: string; className?: string }) {
  return (
    <div
      className={classNames(
        'text-center',
        'sm:pl-huge sm:pr-huge',
        'P4R sm:P2R',
        setupForDark('text-tertiary'),
        className
      )}
    >
      {text}
    </div>
  );
}

export default PlaceholderText;
